import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { SelectCountryComponent } from './select-country.component';
import { SharedModule } from '../shared.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [SelectCountryComponent],
  imports: [SharedModule, MatSelectModule, FormsModule, MatTooltipModule],
  exports: [SelectCountryComponent],
})
export class SelectCountryModule {}
